import { useLocation } from "react-router";

export function useWithVisibleNavigation() {
    const { pathname } = useLocation();

    const included = ["/account/", "/dashboard/", "/admin/", "/clients/", "/oops"];
    const excluded = ["/account/confirm", "/account/recover", "/account/reset"];

    const isExcluded = excluded.some((path) => pathname.startsWith(path));
    if (isExcluded) {
        return false;
    }
    return included.some((path) => pathname.startsWith(path));
}
